import i18n from 'i18next'
import { useRouter } from 'next/router'
import { FC, useEffect, useMemo } from 'react'
import { I18nextProvider, initReactI18next } from 'react-i18next'
import configuration from '~/configuration'

/**
 * commom resources for en
 */
import en_auth from '../../public/locales/en/auth.json'
import en_button from '../../public/locales/en/button.json'
import en_common from '../../public/locales/en/common.json'
import en_form from '../../public/locales/en/form.json'
import en_label from '../../public/locales/en/label.json'
import en_lp from '../../public/locales/en/landing-page.json'
import en_notification from '../../public/locales/en/notification.json'
import en_meta from '../../public/locales/en/meta.json'

/**
 * commom resources for vi
 */
import ja_auth from '../../public/locales/ja/auth.json'
import ja_button from '../../public/locales/ja/button.json'
import ja_common from '../../public/locales/ja/common.json'
import ja_form from '../../public/locales/ja/form.json'
import ja_label from '../../public/locales/ja/label.json'
import jp_lp from '../../public/locales/ja/landing-page.json'
import ja_notification from '../../public/locales/ja/notification.json'
import ja_meta from '../../public/locales/ja/meta.json'

const defaultEnResource = {
  meta: en_meta,
  common: en_common,
  auth: en_auth,
  form: en_form,
  button: en_button,
  label: en_label,
  notification: en_notification,
  lp: en_lp
}
const defaultjaResource = {
  meta: ja_meta,
  common: ja_common,
  auth: ja_auth,
  form: ja_form,
  button: ja_button,
  label: ja_label,
  notification: ja_notification,
  lp: jp_lp
}

const withTranslateProvider = <F extends object>(
  Component: FC<F>,
  pageResources: {
    en: { [nameSpace: string]: object }
    ja: { [nameSpace: string]: object }
  } = { en: {}, ja: {} }
) => {
  const WithTranslateProvider = <T extends F>(props: T) => {
    const router = useRouter()
    useEffect(() => {}, [])
    const i18nInstance = useMemo(() => {
      i18n.use(initReactI18next).init({
        resources: {
          en: { ...defaultEnResource, ...pageResources.en },
          ja: { ...defaultjaResource, ...pageResources.ja }
        },
        lng: router.locale,
        fallbackLng: configuration.site.locale,
        interpolation: {
          escapeValue: false
        }
      })
      return i18n
    }, [router.locale])
    return (
      <I18nextProvider i18n={i18nInstance}>
        <Component {...props} />
      </I18nextProvider>
    )
  }
  return WithTranslateProvider
}
export default withTranslateProvider
